const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_URL = '/branch';

// دالة معالجة أخطاء موحدة
const handleError = async (response, fallbackMessage = "حدث خطأ غير متوقع") => {
    let message = fallbackMessage;
    try {
        const data = await response.json();
        message = data?.message || data?.error || fallbackMessage;
    } catch (_) {
        try {
            const text = await response.text();
            message = text || fallbackMessage;
        } catch (_) {
            // fallback stays
        }
    }

    console.error(`API Error [${response.status}]: ${message}`);
    throw new Error(message);
};

// جلب بيانات فرع محدد
export const getBranchDetails = async (id) => {
    const response = await fetch(`${BASE_URL}${API_URL}/${id}`);
    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء تحميل بيانات الفرع");
    }
    return await response.json();
};

// جلب الفروع التابعة لمؤسسة
export const getInstitutionBranches = async (id) => {
    const response = await fetch(`${BASE_URL}${API_URL}/institution/${id}`);
    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء تحميل فروع المؤسسة");
    }
    return await response.json();
};

// تعديل بيانات فرع
export const editBranch = async (token, id, newData) => {
    const response = await fetch(`${BASE_URL}${API_URL}/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(newData),
    });

    if (!response.ok) {
        await handleError(response, "فشل تعديل بيانات الفرع");
    }

    return await response.json();
};

// حذف فرع
export const deleteBranch = async (token, id) => {
    const response = await fetch(`${BASE_URL}${API_URL}/${id}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        await handleError(response, "فشل حذف الفرع");
    }

    return await response.json();
};

// إضافة فرع جديد
export const addBranch = async (token, data) => {
    const response = await fetch(`${BASE_URL}${API_URL}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(data),
    });

    if (!response.ok) {
        await handleError(response, "فشل إضافة الفرع");
    }

    return await response.json();
};
